export default __webpack_public_path__ + "static/media/briefcase-sm.45c7b94f.svg";